import React, { useState } from "react";
import { Button as AntdButton, Input as AntdInput, Switch as AntdSwitch } from "antd";
import "antd/dist/antd.css";
import { AppShell } from "../../components/shell";
import { ROLES } from "../../helpers/constants";
import { Button, Card, CardTitle, Badge } from "../../components/ds";

/**
 * DEV-ONLY preview of the shared AppShell. Lets us eyeball the sidebar (per role)
 * + topbar framing without logging in or touching production wiring.
 */
const ROLE_OPTIONS = [
  ROLES.COMPANY_ADMIN,
  ROLES.COMPANY_EMPLOYEE,
  ROLES.STATE_DOT_ADMIN,
  ROLES.PLATFORM_ADMIN,
];

const demoUser = {
  name: "A. Sterling",
  user_name: "A. Sterling",
  email: "a.sterling@transit.gov",
  organization: "Metro Transit Authority",
};

export default function ShellPreview() {
  const [role, setRole] = useState(ROLES.COMPANY_ADMIN);

  return (
    <AppShell role={role} user={demoUser}>
      <div style={{ padding: "32px clamp(16px, 5vw, 64px)" }}>
        <Badge variant="info">DEV ONLY — SHELL PREVIEW</Badge>
        <h1
          style={{
            fontFamily: "var(--cb-font-sans)",
            fontWeight: 700,
            fontSize: "var(--cb-text-headline-lg)",
            margin: "12px 0 8px",
          }}
        >
          App Shell
        </h1>
        <p style={{ color: "var(--cb-muted-foreground)", marginBottom: 24 }}>
          Switch role to preview per-role navigation. Content area is where a
          migrated (or un-migrated antd) page would render.
        </p>

        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 24 }}>
          {ROLE_OPTIONS.map((r) => (
            <Button
              key={r}
              size="sm"
              variant={r === role ? "primary" : "secondary"}
              onClick={() => setRole(r)}
            >
              {r}
            </Button>
          ))}
        </div>

        <Card>
          <CardTitle>Content region</CardTitle>
          <p style={{ color: "var(--cb-muted-foreground)", marginTop: 8 }}>
            Page content mounts here inside the shell.
          </p>
        </Card>

        <Card style={{ marginTop: 16 }}>
          <CardTitle>Un-migrated antd content (bridge active)</CardTitle>
          <p style={{ color: "var(--cb-muted-foreground)", margin: "8px 0 16px" }}>
            Legacy antd elements recolored to the design tokens by the bridge, so
            they stay coherent inside the shell until the route is migrated.
          </p>
          <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
            <AntdButton type="primary">antd Primary</AntdButton>
            <AntdButton>antd Default</AntdButton>
            <AntdInput placeholder="antd input" style={{ width: 200 }} />
            <AntdSwitch defaultChecked />
          </div>
        </Card>
      </div>
    </AppShell>
  );
}
